webpackJsonp([3528254163161,126761542922144,223471745239978,128080132386104],{

/***/ 527:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = ClickAround;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ClickAround() {
	  return _react2.default.createElement(
	    "svg",
	    { width: "180", height: "180", viewBox: "0 0 180 180" },
	    _react2.default.createElement("path", {
	      className: "fill-silver opacity-60",
	      d: "M22.1 28.6c2.1-1.9 4.8-4.6 7.7-3.3.5.2.8.7.5 1.5-.8 2.3-2.9 2.2-4.7 3.5-1.5 1.2-2.8 2.7-3 4.6-.1 1.1.1 2.5.8 3.5.8 1.3 2.2 1.4 3.5 1.9 2 .8 3.3-2 5-2.1 1.7-.1.6 2.3.2 2.9-1.9 2.9-5.4 2.5-8.4 1.7-3.5-1-5.4-4.6-4.8-8.3.4-2.5 1.5-4.4 3.2-5.9zM34.7 21.2c.7-1.5 3.6-1.9 3.7.4l-.2 1.5c0 2.7.2 5.5 0 8.1-.2 4.2 1 8.4-.8 12.1-.5 1.2-1.9 1.1-3 .6-.6-.4-.8-1.3-.6-2.1 1.1-3.8.8-7.6.9-11.5.3-3-1.3-6.4 0-9.1zM42.6 30.4c.5-1 1.8-1.3 3-.8.7.3 1.5 1.2.8 1.8-1.2 1.7-.5 3.3-1 4.8-.6 1.8.5 3.5 0 5.3 0 .2-.2.5-.3.5-1.2.3-2.6.5-3-.7-.6-2.2-.2-4.5-.2-6.6 0-1.5 0-3 .7-4.3zm.7-7.1c1.2-.7 2.7-.6 3.4.3.7 1-.3 2.7-1 3.1-.9.5-2.1.3-2.9-.7-.6-.6 0-2.3.5-2.7zM51 28.6c2.1-1.9 4.8-4.6 7.7-3.3.5.2.8.7.5 1.5-.8 2.3-2.9 2.2-4.7 3.5-1.5 1.2-2.8 2.7-3 4.6-.1 1.1.1 2.5.8 3.5.8 1.3 2.2 1.4 3.5 1.9 2 .8 3.3-2 5-2.1 1.7-.1.6 2.3.2 2.9-1.9 2.9-5.4 2.5-8.4 1.7-3.5-1-5.4-4.6-4.8-8.3.4-2.5 1.5-4.4 3.2-5.9zM62.5 21.1c.3-.9 1.9-1.4 3.1-1 .2.2.5.7.5.8 0 3.8-.5 7.4-.3 11.1.2.3.7.2.9.2 1.9-1.4 3.8-3.6 6.2-2.1 1 .5.2 1.6-.5 1.9-1.2.8-2.8 1.4-4 2.5 2.7 2.1 5.1 4.3 7.5 6.5.5.7 0 1.4-.5 1.7-.7.9-2.1.9-2.6.2-1.9-1.9-4-3.4-6-5.1 0 0-.7-.5-.5.3-.2 1.5.5 3.2.3 4.8-.2 1.5-2.6 1.6-2.9.8-1.9-4.4-1.5-9.6-1.2-14.5.2-2.6-1.1-5.7 0-8.1zM91.6 43.7c-2.7-.5-5.7-.3-7.3-2.9-1-1.4-.6-4.1.3-5.3 3.1-4.1 8.4-2.8 8.5-3 .3-.5.6-2.2-.3-2.4-2.2-.5-3.6.5-5.7 1.2-1.5.5-1.9-2.5-1.5-2.9 2.7-1.9 8.4-2.9 10.1.6 1.5 3.2-.3 6.5-.6 10-.2 2.3-.4 7.4-2.5 6-.4-.3-.4-1.3-1-1.3zm1.1-8.4c-2.2.8-6 .2-6.1 3.5 0 1.7 5.3 2.5 5.6 1.8.3-2 1.3-3.3.5-5.3zM97.8 27c1.9-1.7 4.2.6 3.8 3 2.3-.4 2.8-3.6 5.5-2.8.9.4 2.1.8 1.3 1.9-1.5 2.1-3.8 3.1-5.4 5.4-.5.8-.2 1.9-.6 2.7-.4.6-.4 1.5.4 2.5.8.9.6 2.8-.4 3.8-.8 1.1-2.5 1.1-3.2.2-.6-.4-.6-1-.6-1.7.2-3-.2-6.3-.6-9.3 0-2.1-1.9-4.2-.2-5.7zM110 31.7c.6-2.1 2-3.2 2.4-4.3.9-2.1 3.6-1.4 5 .2 1 1.1 1.5 2.4 1.9 3.7.8 3-.6 5.5-2.6 7.7-.8.9-2.8.9-3.8.3-2.7-1.5-3.8-4.7-2.9-7.6zm5-1.4c-.8-.9-4.9 4.4-1 5.3 2.8.6 3-3.1 1-5.3zM121.4 27.1c1.3-.6 3.2-.2 3.2 1.1 0 2.5-.4 5 0 7.4.4 1.5.8 5.2 2.3 4.2 3.3-2.2 4.2-7.4 1.9-11.1-.6-.9-1.1-2.4-.2-2.8 2.7-1.1 4.6 2.3 4.8 4.6.3 4.6-1 10.2-5.1 12-6.5 2.8-8.2-6.6-7.8-11.8.1-1.3-.2-2.8.9-3.6zM135.3 29.8c.5-1.1 2.6-1.1 3 .2.3 1-.3 1.9-.3 2.9.2.2.3.6.3.5 1.3-2.1 2.4-4.5 5.1-3.7 2.1 3.4 1.9 7.6 2.1 11.4.2.6.2 1.7-.5 1.9-1 .3-2.4.6-2.6-.3-.5-3.2-.2-6.2-.8-9.3-1.9 2.1-2.2 5-3.7 7.6-.6 1-2.2 1.1-2.7 0-.5-1.4-.2-3.2-.2-4.8.1-2.2-.4-4.7.3-6.4zM156.4 28c.9-.8.5-2.7 1.1-4 .5-.9 1.6-1.7 2.5-1.3.4.2 1.3.8 1.1 1.5-2.2 6-2 12.6-.9 19 0 .3-.9.9-1.5.9-1.6.2-1.6-2.2-2.5-2.4-1.5 0-3 .4-4.4-.5-1.9-1.3-4.2-2.5-4.2-5.3.1-4.8 5.9-5.6 8.8-7.9zm-.5 10.2c-.3-2.2.4-4.2.4-6.4-2 0-5.1 1.1-4.7 3.5.2 1.8 2.2 3.6 4.3 2.9z"
	    }),
	    _react2.default.createElement("path", {
	      className: "fill-blue",
	      d: "M91.2 70c-.7 0-1.4.3-2 .8-1.8 1.7-1.4 6.3 1.1 13.8-1.1 18.4-11.4 31.4-20.4 39.3-11 9.7-26.1 17.2-41.9 20.9-2.7-1.6-5.3-1-6.8.1s-2 2.8-1.4 4.3c.4 1 1.6 2 3.4 1.7 18.8-3.2 37-11.7 50-23.2 15.7-13.8 23.3-31.3 22.1-50.4-.2-2.7-.8-6.2-3.1-7.1-.3-.2-.6-.2-1-.2zM33 128.4c-1.1 0-3 .6-8.1 8.9-3.7 3.3-8.8 6.9-13.7 8.5-1.7.6-2.7.7-3 .8-1.9.4-2.2 2-2.2 2.8.1.8.7 2.2 2.6 2.2h.2c1.9 0 7.8.4 17 4.8.1.1.2.1.3.1 1.3.7 2.8 1.4 4.2 2.2 1.8 1 3.8 1.8 5.3.7.8-.6 1.2-1.7 1-2.7-.6-2.9-6.5-4.4-8.7-5-3.7-1.8-6.9-3-9.7-3.7 7.2-3.9 13.7-10.1 15.9-13.1 2.1-2.8 1.8-4.2 1.4-5-.4-.9-1.3-1.5-2.3-1.5h-.2z"
	    })
	  );
	}
	module.exports = exports["default"];

/***/ }),

/***/ 120:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _apps2x = __webpack_require__(324);
	
	var _apps2x2 = _interopRequireDefault(_apps2x);
	
	var _appStore2x = __webpack_require__(323);
	
	var _appStore2x2 = _interopRequireDefault(_appStore2x);
	
	var _watch2x = __webpack_require__(326);
	
	var _watch2x2 = _interopRequireDefault(_watch2x);
	
	var _files2x = __webpack_require__(325);
	
	var _files2x2 = _interopRequireDefault(_files2x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var assets = {
	  apps: {
	    alt: 'Marvel mobile apps for prototyping',
	    maxWidth: 700,
	    src: _apps2x2.default,
	    hasShadow: false
	  },
	  appStore: {
	    alt: 'Apple App Store',
	    maxWidth: 180,
	    src: _appStore2x2.default,
	    hasShadow: false
	  },
	  watch: {
	    alt: 'Apple Watch illustration',
	    maxWidth: 174,
	    src: _watch2x2.default,
	    hasShadow: false
	  },
	  files: {
	    alt: 'Supported files illustration',
	    maxWidth: 280,
	    src: _files2x2.default,
	    hasShadow: false
	  }
	};
	
	exports.default = assets;
	module.exports = exports['default'];

/***/ }),

/***/ 323:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 324:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/apps@2x-4f5726afb22d2a76eadc973f937118a3.jpg";

/***/ }),

/***/ 325:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/files@2x-f56b0fd49169ebf00b44a4dd1f30180d.jpg";

/***/ }),

/***/ 326:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/watch@2x-6177d25555f7aa2cec26f31b9cf4519f.jpg";

/***/ }),

/***/ 635:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Images;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactResponsive = __webpack_require__(18);
	
	var _reactResponsive2 = _interopRequireDefault(_reactResponsive);
	
	var _maxWidth = __webpack_require__(10);
	
	var _maxWidth2 = _interopRequireDefault(_maxWidth);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _position = __webpack_require__(44);
	
	var _position2 = _interopRequireDefault(_position);
	
	var _heading = __webpack_require__(7);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	var _paragraph = __webpack_require__(9);
	
	var _paragraph2 = _interopRequireDefault(_paragraph);
	
	var _align = __webpack_require__(11);
	
	var _align2 = _interopRequireDefault(_align);
	
	var _button = __webpack_require__(14);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _grid = __webpack_require__(5);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _ClickAround = __webpack_require__(527);
	
	var _ClickAround2 = _interopRequireDefault(_ClickAround);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Images() {
	  return _react2.default.createElement(
	    _spacing2.default,
	    { size: 'l', sizeM: 'xl', type: 'padding', position: 'topBottom' },
	    _react2.default.createElement(
	      _maxWidth2.default,
	      { value: 720 },
	      _react2.default.createElement(
	        _grid2.default,
	        { columns: 2, size: 'l', alignItems: 'center', justifyContent: 'center' },
	        _react2.default.createElement(
	          _grid.GridItem,
	          { columnSpan: 2, columnSpanM: 1 },
	          _react2.default.createElement(
	            _position2.default,
	            { type: 'relative' },
	            _react2.default.createElement('iframe', {
	              src: 'https://marvelapp.com/aj3a74?emb=1',
	              width: '270',
	              height: '420',
	              allowTransparency: 'true',
	              frameBorder: '0'
	            }),
	            _react2.default.createElement(
	              _reactResponsive2.default,
	              { minWidth: 770 },
	              _react2.default.createElement(
	                _position2.default,
	                { type: 'absolute', right: -100, top: -100 },
	                _react2.default.createElement(_ClickAround2.default, null)
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _grid.GridItem,
	          { columnSpan: 2, columnSpanM: 1 },
	          _react2.default.createElement(
	            _align2.default,
	            { type: 'center', typeM: 'left' },
	            _react2.default.createElement(
	              _spacing2.default,
	              { size: 's', type: 'padding', position: 'topBottom' },
	              _react2.default.createElement(
	                _heading2.default,
	                { tag: 'h2', weight: 'semibold', size: 'xl' },
	                'Create and view prototypes on the web or on your phone'
	              )
	            ),
	            _react2.default.createElement(
	              _paragraph2.default,
	              { size: 'l', color: 'slate' },
	              'Even if you don\'t have a watch, you can still create and view prototypes using our web app. Click around on the example on the left then sign up to get started.'
	            ),
	            _react2.default.createElement(
	              _spacing2.default,
	              { size: 'm', type: 'padding', position: 'topBottom' },
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/signup' },
	                _react2.default.createElement(
	                  _button2.default,
	                  { shape: 'rounded', size: 'large' },
	                  'Get started'
	                )
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 636:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Images;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _maxWidth = __webpack_require__(10);
	
	var _maxWidth2 = _interopRequireDefault(_maxWidth);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _heading = __webpack_require__(7);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	var _paragraph = __webpack_require__(9);
	
	var _paragraph2 = _interopRequireDefault(_paragraph);
	
	var _align = __webpack_require__(11);
	
	var _align2 = _interopRequireDefault(_align);
	
	var _grid = __webpack_require__(5);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _Image = __webpack_require__(6);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _assets = __webpack_require__(120);
	
	var _assets2 = _interopRequireDefault(_assets);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Images() {
	  return _react2.default.createElement(
	    _spacing2.default,
	    { size: 'l', sizeM: 'xl', type: 'padding', position: 'topBottom' },
	    _react2.default.createElement(
	      _maxWidth2.default,
	      { value: 720 },
	      _react2.default.createElement(
	        _grid2.default,
	        { columns: 2, size: 'l', alignItems: 'center', justifyContent: 'center' },
	        _react2.default.createElement(
	          _grid.GridItem,
	          { columnSpan: 2, columnSpanM: 1 },
	          _react2.default.createElement(
	            _align2.default,
	            { type: 'center', typeM: 'left' },
	            _react2.default.createElement(
	              _spacing2.default,
	              { size: 's', type: 'padding', position: 'topBottom' },
	              _react2.default.createElement(
	                _heading2.default,
	                { tag: 'h2', weight: 'semibold', size: 'xl' },
	                'Access your design files anywhere'
	              )
	            ),
	            _react2.default.createElement(
	              _paragraph2.default,
	              { size: 'l', color: 'slate' },
	              'Create screens directly in Marvel, add your images from Sketch or upload any designs.'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _grid.GridItem,
	          { columnSpan: 2, columnSpanM: 1 },
	          _react2.default.createElement(_Image2.default, _assets2.default.files)
	        )
	      )
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 637:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Ideas;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _maxWidth = __webpack_require__(10);
	
	var _maxWidth2 = _interopRequireDefault(_maxWidth);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _heading = __webpack_require__(7);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	var _paragraph = __webpack_require__(9);
	
	var _paragraph2 = _interopRequireDefault(_paragraph);
	
	var _align = __webpack_require__(11);
	
	var _align2 = _interopRequireDefault(_align);
	
	var _grid = __webpack_require__(5);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _Image = __webpack_require__(6);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _assets = __webpack_require__(120);
	
	var _assets2 = _interopRequireDefault(_assets);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Ideas() {
	  return _react2.default.createElement(
	    _spacing2.default,
	    { size: 'l', sizeM: 'xl', type: 'padding', position: 'topBottom' },
	    _react2.default.createElement(
	      _maxWidth2.default,
	      { value: 720 },
	      _react2.default.createElement(
	        _grid2.default,
	        { columns: 2, size: 'l', alignItems: 'center', justifyContent: 'center' },
	        _react2.default.createElement(
	          _grid.GridItem,
	          null,
	          _react2.default.createElement(_Image2.default, _assets2.default.apps)
	        ),
	        _react2.default.createElement(
	          _grid.GridItem,
	          { columnSpan: 2, columnSpanM: 1 },
	          _react2.default.createElement(
	            _align2.default,
	            { type: 'center', typeM: 'left' },
	            _react2.default.createElement(
	              _spacing2.default,
	              { size: 's', type: 'padding', position: 'topBottom' },
	              _react2.default.createElement(
	                _heading2.default,
	                { tag: 'h2', weight: 'semibold', size: 'xl' },
	                'Bring your app ideas to life'
	              )
	            ),
	            _react2.default.createElement(
	              _paragraph2.default,
	              { size: 'l', color: 'slate' },
	              'Build your app prototypes on the web or directly on your iPhone or iPad. Once you\u2019re ready you can beam them directly to the Apple Watch and preview.'
	            )
	          )
	        )
	      )
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 1255:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = AppleWatchPrototyping;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _maxWidth = __webpack_require__(10);
	
	var _maxWidth2 = _interopRequireDefault(_maxWidth);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _heading = __webpack_require__(7);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	var _paragraph = __webpack_require__(9);
	
	var _paragraph2 = _interopRequireDefault(_paragraph);
	
	var _link = __webpack_require__(15);
	
	var _link2 = _interopRequireDefault(_link);
	
	var _pageWrap = __webpack_require__(8);
	
	var _pageWrap2 = _interopRequireDefault(_pageWrap);
	
	var _align = __webpack_require__(11);
	
	var _align2 = _interopRequireDefault(_align);
	
	var _IntegrationsCta = __webpack_require__(118);
	
	var _IntegrationsCta2 = _interopRequireDefault(_IntegrationsCta);
	
	var _Whitespace = __webpack_require__(35);
	
	var _Whitespace2 = _interopRequireDefault(_Whitespace);
	
	var _Image = __webpack_require__(6);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _Page = __webpack_require__(16);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _assets = __webpack_require__(120);
	
	var _assets2 = _interopRequireDefault(_assets);
	
	var _ideas = __webpack_require__(637);
	
	var _ideas2 = _interopRequireDefault(_ideas);
	
	var _embed = __webpack_require__(635);
	
	var _embed2 = _interopRequireDefault(_embed);
	
	var _files = __webpack_require__(636);
	
	var _files2 = _interopRequireDefault(_files);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AppleWatchPrototyping() {
	  return _react2.default.createElement(
	    _Page2.default,
	    {
	      title: 'Create free Apple Watch prototypes | Marvel',
	      meta: [{
	        name: 'description',
	        content: 'Prototype your sketches and design mockups for the Apple Watch with Marvel'
	      }, {
	        name: 'keywords',
	        content: 'apple watch, prototyping, prototype, watchOS, watch prototyping'
	      }],
	      header: true,
	      footer: true
	    },
	    _react2.default.createElement(
	      _pageWrap2.default,
	      { size: 'l' },
	      _react2.default.createElement(_Whitespace2.default, { size: 's', sizeS: 'l', sizeM: 'xl' }),
	      _react2.default.createElement(
	        _align2.default,
	        { type: 'center' },
	        _react2.default.createElement(
	          _spacing2.default,
	          { size: 's', type: 'padding', position: 'bottom' },
	          _react2.default.createElement(_Image2.default, _assets2.default.watch)
	        ),
	        _react2.default.createElement(
	          _maxWidth2.default,
	          { value: 720 },
	          _react2.default.createElement(
	            _heading2.default,
	            { tag: 'h1', weight: 'semibold', size: 'mega' },
	            'View your sketches and design mockups on the Apple Watch'
	          )
	        ),
	        _react2.default.createElement(
	          _spacing2.default,
	          { size: 's', type: 'padding', position: 'topBottom' },
	          _react2.default.createElement(
	            _maxWidth2.default,
	            { value: 720 },
	            _react2.default.createElement(
	              _paragraph2.default,
	              { size: 'xxxl', color: 'slate' },
	              'Marvel is the easiest way to turn your sketches and mockups into prototypes and view them on the Apple Watch!'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _spacing2.default,
	          { size: 's', type: 'padding', position: 'top' },
	          _react2.default.createElement(
	            _spacing2.default,
	            { size: 'l', type: 'padding', position: 'bottom' },
	            _react2.default.createElement(
	              _link2.default,
	              {
	                url: 'https://itunes.apple.com/us/app/marvel-app/id765801658?mt=8',
	                target: '_blank'
	              },
	              _react2.default.createElement(_Image2.default, _assets2.default.appStore)
	            )
	          )
	        ),
	        _react2.default.createElement(_ideas2.default, null),
	        _react2.default.createElement(_files2.default, null),
	        _react2.default.createElement(_embed2.default, null)
	      )
	    ),
	    _react2.default.createElement(_IntegrationsCta2.default, null)
	  );
	}
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-apple-watch-prototyping-index-js-c9fc2dcf5def636a8659.js